import React from 'react';
import {Modal, StyleSheet, Animated, KeyboardAvoidingView, Platform} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import NPS from '../../../NPS/NPS';

interface NPSModalProps {
  visible: boolean;
  onClose: () => void;
  onSurvey: () => void;
}

const NPSModal: React.FC<NPSModalProps> = ({visible, onClose}) => {
  const insets = useSafeAreaInsets();
  const slideAnim = React.useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    if (visible) {
      Animated.spring(slideAnim, {
        toValue: 1,
        useNativeDriver: true,
        tension: 65,
        friction: 11,
      }).start();
    } else {
      Animated.spring(slideAnim, {
        toValue: 0,
        useNativeDriver: true,
        tension: 65,
        friction: 11,
        
      }).start();
    }
  }, [visible]);

  const translateY = slideAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [600, 0],
  });

  return (
    <Modal
      key={visible ? 'visible' : 'hidden'}
      transparent={true}
      presentationStyle="overFullScreen"
      visible={visible}
      onRequestClose={onClose}
      animationType="none">
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={styles.centeredView}>
        <Animated.View
          style={[
            styles.modalView,
            {
              transform: [{translateY}],
              paddingBottom: Math.max(insets.bottom, 20),
            },
          ]}>
          <NPS onClose={onClose} />
        </Animated.View>
      </KeyboardAvoidingView>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalView: {
    backgroundColor: 'white',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: -2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: '100%',
    height: '60%',
  },
});

export default NPSModal;
